export default __webpack_public_path__ + "sportoto_siyah.png";